import th from '../JsonLang/th.json'
export const lang = { ...th }